import { Region } from "resource-planner-model";
import {
  FETCH_REGIONS,
  LOAD_REGIONS,
  PERSIST_REGION,
  RegionAction,
  RegionsState,
  REMOVE_REGION,
  REMOVE_REGION_LOCAL,
  UPSERT_REGION
} from "./RegionTypes";

const initialState: RegionsState = {
  items: {},
  loadedAll: false,
  nextToken: undefined,
  synching: false,
};

export default function teamsReducer(
  state = initialState,
  action: RegionAction
): RegionsState {
  switch (action.type) {
    case FETCH_REGIONS:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_REGION:
      return {
        ...state,
        synching: true,
      };
    case PERSIST_REGION:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_REGION_LOCAL: {
      const items = { ...state.items };
      delete items[action.id];
      return {
        ...state,
        items,
        synching: false,
      };
    }
    case UPSERT_REGION:
      return {
        ...state,
        items: {
          ...state.items,
          [action.item.id]: action.item,
        },
        synching: false,
      };
    case LOAD_REGIONS:
      return {
        ...state,
        items: action.items.reduce((all, region) => {
          all[region.id] = region;
          return all;
        }, action.append ? { ...state.items } : {} as { [id: string]: Region }),
        loadedAll: action.loadedAll || false,
        nextToken: action.nextToken,
        synching: false,
      };
    default:
      return state;
  }
}
